import RatingsAndReviewsZone from 'components/Catalog/ProductGrid/CompareModal/Zones/RatingsAndReviewsZone/RatingsAndReviewsZone';

export default RatingsAndReviewsZone;
